(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["grid-density-controls"] && !Shopify.designMode) return;
  try {
    (() => {
    const DESKTOP = new Set(['cols-6', 'cols-4', 'cols-2']);

    const normalize = (value, viewport) => {
      if (viewport === 'mobile') {
        if (value === 'mobile-single' || value === 'cols-2') return 'mobile-single';
        return 'default';
      }
      if (value === 'zoom-out' || value === 'cols-6') return 'cols-6';
      if (value === 'cols-2') return 'cols-2';
      return 'cols-4';
    };

    const applyLayout = (rawValue) => {
      const grid = document.querySelector('results-list ul.product-grid, ul.product-grid[ref="grid"], ul.product-grid');
      if (!grid) return;
      const desktop = window.matchMedia('(min-width: 750px)').matches;
      const viewport = desktop ? 'desktop' : 'mobile';
      const value = normalize(rawValue, viewport);
      grid.setAttribute('product-grid-view', value);
      sessionStorage.setItem(`product-grid-view-${viewport}`, value);
      const name = desktop ? 'grid' : 'grid-mobile';
      document.querySelectorAll(`input.column-options__option-input[name="${name}"]`).forEach((input) => {
        input.checked = input.value === value;
      });
    };

    window.__ukApplyProductGridView = applyLayout;
    window.__ukNormalizeProductGridView = normalize;

    if (!window.__ukGridDensityBound) {
      window.__ukGridDensityBound = true;
      document.addEventListener('change', (event) => {
        const input = event.target;
        if (!(input instanceof HTMLInputElement)) return;
        if (!input.classList.contains('column-options__option-input')) return;
        event.stopPropagation();
        applyLayout(input.value);
      }, true);
    }
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["uk-size-chart"] && !Shopify.designMode) return;
  try {
    if (!window.__ukSizeChartReady) {
    window.__ukSizeChartReady = true;

    const dialogFor = (el) => {
      const root = el.closest('.product-details, .product-information, .shopify-section') || document;
      return root.querySelector('[data-uk-size-chart-dialog]');
    };

    const openDialog = (dialog) => {
      if (!dialog) return;
      if (typeof dialog.showModal === 'function') dialog.showModal();
      else dialog.setAttribute('open', '');
    };

    const closeDialog = (dialog) => {
      if (!dialog) return;
      if (typeof dialog.close === 'function') dialog.close();
      else dialog.removeAttribute('open');
    };

    document.addEventListener('click', (event) => {
      const openBtn = event.target.closest('[data-uk-size-chart-open]');
      if (openBtn) {
        event.preventDefault();
        openDialog(dialogFor(openBtn));
        return;
      }

      const closeBtn = event.target.closest('[data-uk-size-chart-close]');
      if (closeBtn) {
        event.preventDefault();
        closeDialog(closeBtn.closest('[data-uk-size-chart-dialog]'));
        return;
      }

      const dialog = event.target.closest('[data-uk-size-chart-dialog]');
      if (dialog && event.target === dialog) closeDialog(dialog);
    });

    document.addEventListener('keydown', (event) => {
      if (event.key !== 'Escape') return;
      document.querySelectorAll('[data-uk-size-chart-dialog][open]').forEach((dialog) => {
        closeDialog(dialog);
      });
    });
  }
  } catch(e) { console.error(e); }
})();

})();
